var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxRequaredSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "px-requared-sing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "8.99731903 12 8.58981233 9.00795756 10.9919571 10.8541114 12 9.0928382 9.19034853 7.98938992 11.9785523 6.88594164 11.0348525 5.18832891 8.58981233 7.03448276 9.01876676 4 7.02412869 4 7.45308311 7.03448276 4.98659517 5.18832891 4.02144772 6.9071618 6.80965147 7.96816976 4 9.07161804 5.02949062 10.8753316 7.43163539 9.00795756 7.02412869 12"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-62.5%",
    y: "-50.0%",
    width: "225.0%",
    height: "225.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0106581536   0 0 0 0 0.0106581536   0 0 0 0 0.0106581536  0 0 0 0 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6.-Accident-flow-\\u2013-EG-fleet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11n.-Damage-photos-\\u2013-Additional-photos-\\u2013-taken",
    transform: "translate(-74.000000, -241.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "::-Car-overview",
    transform: "translate(16.000000, 189.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.-Front-left-diagonal-\\u2013-taken",
    transform: "translate(0.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "px-requared-sing",
    transform: "translate(54.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#ED523B",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxRequaredSign);
export default __webpack_public_path__ + "static/media/px-requared-sign.d3d073a4aa2cc98d62f1c50d0a9f94cd.svg";
export { ForwardRef as ReactComponent };